__turbopack_context__.v({
  "bgGradientBlack": "style-module__PB2tgq__bgGradientBlack",
  "bgGradientGray": "style-module__PB2tgq__bgGradientGray",
  "bgGradientRed": "style-module__PB2tgq__bgGradientRed",
  "featuresItem": "style-module__PB2tgq__featuresItem",
});
